export function extractCounterButtonProps({ counter }) {
    return { counter };
}
export function extractCommonButtonProps({ disabled, href, icon, label, loading, onClick, onFocus, onBlur, onKeyDown, }) {
    return { disabled, href, icon, label, loading, onClick, onKeyDown, onFocus, onBlur };
}
